import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import AdminLayout from '../../layouts/AdminLayout';
import { Link, useLocation } from 'react-router-dom';

const MyOrders = () => {
    const location = useLocation();
    const [orders, setOrders] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchMyOrders = async () => {
            try {
                const res = await axios.get('/orders/my-orders');
                setOrders(res.data);
            } catch (error) {
                console.error('Siparişler yüklenemedi');
            }
        };
        fetchMyOrders();
    }, []);

    useEffect(() => {
        if (location.state?.status) {
            setStatusFilter(location.state.status);
        }
    }, [location.state]);

    const getStatusBadge = (status) => {
        switch (status) {
            case 'pending': return <span className="badge bg-warning text-dark">Onay Bekliyor</span>;
            case 'approved': return <span className="badge bg-info text-dark">Onaylandı</span>;
            case 'preparing': return <span className="badge bg-primary">Hazırlanıyor</span>;
            case 'shipped': return <span className="badge bg-secondary">Yola Çıktı</span>;
            case 'delivered': return <span className="badge bg-success">Teslim Edildi</span>;
            case 'cancelled': return <span className="badge bg-danger">İptal Edildi</span>;
            default: return <span className="badge bg-light text-dark">{status}</span>;
        }
    };

    // Filtreleme Mantığı
    const filteredOrders = orders.filter(order => {
        const orderDate = new Date(order.created_at);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;
        if (end) end.setHours(23, 59, 59, 999);

        const matchesStatus = statusFilter ? order.status === statusFilter : true;
        const matchesSearch = searchTerm ? order.order_number.toLowerCase().includes(searchTerm.toLowerCase()) : true;
        const matchesDate = (!start || orderDate >= start) && (!end || orderDate <= end);

        return matchesStatus && matchesSearch && matchesDate;
    });

    return (
        <AdminLayout>
            <h2>Sipariş Geçmişim</h2>
            
            {/* Filtreleme Alanı */}
            <div className="card shadow-sm mt-3 mb-3">
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Sipariş No Ara..." 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <select 
                                className="form-select" 
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="">Tüm Durumlar</option>
                                <option value="pending">Onay Bekliyor</option>
                                <option value="approved">Onaylandı</option>
                                <option value="preparing">Hazırlanıyor</option>
                                <option value="shipped">Yola Çıktı</option>
                                <option value="delivered">Teslim Edildi</option>
                                <option value="cancelled">İptal Edildi</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <div className="input-group">
                                <span className="input-group-text bg-light">Başlangıç</span>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input-group">
                                <span className="input-group-text bg-light">Bitiş</span>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-1">
                            <button 
                                className="btn btn-outline-secondary w-100"
                                onClick={() => {
                                    setSearchTerm('');
                                    setStatusFilter('');
                                    setStartDate('');
                                    setEndDate('');
                                }}
                                title="Filtreleri Temizle"
                            >
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm">
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Sipariş No</th>
                                <th>Tarih</th>
                                <th>Ödeme Yöntemi</th>
                                <th>Toplam Tutar</th>
                                <th>Durum</th>
                                <th>Detay</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredOrders.map(order => (
                                <tr key={order.id}>
                                    <td>{order.order_number}</td>
                                    <td>{new Date(order.created_at).toLocaleDateString('tr-TR')}</td>
                                    <td>
                                        {order.payment_method === 'bank_transfer' ? 'Havale / EFT' : 'Kapıda Ödeme'}
                                    </td>
                                    <td>{Number(order.final_amount).toLocaleString('tr-TR', { style: 'currency', currency: 'EUR' })}</td>
                                    <td>{getStatusBadge(order.status)}</td>
                                    <td>
                                        <Link to={`/orders/${order.id}`} className="btn btn-sm btn-primary">Görüntüle</Link>
                                    </td>
                                </tr>
                            ))}
                            {filteredOrders.length === 0 && (
                                <tr><td colSpan="6" className="text-center p-4">Kriterlere uygun sipariş bulunamadı.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    );
};

export default MyOrders;
